import { QueryReturnValue } from "@reduxjs/toolkit/dist/query/baseQueryTypes";
import { BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, FetchBaseQueryMeta } from "@reduxjs/toolkit/query/react";
import jwtDecode from "jwt-decode";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { addRegisterIng } from "src/store/reducers/asReduce";
import { getCookie, logoutCookie, setCookie } from "./cookieUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

const baseQuery = fetchBaseQuery({
  baseUrl: serverIp + "/",
  // credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const ac_token = getCookie("ac_token");
    headers.set("Authorization", `bearer ${ac_token}`);
    return headers;
  },
});

const refleshToken = fetchBaseQuery({
  baseUrl: serverIp + "/",
  // credentials: "include",
  // prepareHeaders: (headers, { getState }) => {
  //     const ac_token = getCookie("ac_token");
  //     const userInfo: any = jwtDecode(ac_token);
  //     const afterTime = userInfo.exp * 1000;
  //     const currentTime = new Date().getTime();
  //     const resultTime = afterTime - currentTime;
  //     console.log(resultTime);
  //     if (resultTime > 0) {
  //       headers.set("Authorization", `bearer ${ac_token}`);
  //     }else{
  //       headers.set("Authorization", `bearer ${ac_token}`);
  //     }
  //   return headers;
  // },
});

let check = false;
export const asRegisterCheck = () => {
  // const dispatch = useDispatch();
  // dispatch(addRegisterIng(check));
  return check;
};

export const asRegisterInit = () => {
  // const dispatch = useDispatch();
  // dispatch(addRegisterIng(check));
  check = false;
};

export const baseQueryWithIntercept: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (api.endpoint === "addAs") {
    const tempData: any = result.data;
    if (tempData.message) {
      check = true;
    }
  }
  if (api.endpoint === "updateAs") {
    const tempData: any = result.data;
    if (tempData.message) {
      check = true;
    }
  }
  if (api.endpoint === "addReport") {
    const tempData: any = result.data;
    if (tempData.message) {
      check = true;
    }
  }
  if (api.endpoint === "updateReport") {
    const tempData: any = result.data;
    if (tempData.message) {
      check = true;
    }
  }
  if (api.endpoint === "addNotice") {
    const tempData: any = result.data;
    if (tempData.message) {
      check = true;
    }
  }

  if (result.error) {
    if (result.error.status === 404) {
      const currentUrl = window.location.href;
      if (currentUrl.includes("notice-detail")) window.location.replace("/error");
      if (currentUrl.includes("fulfill-detail")) window.location.replace("/error");
    }
    if (result.error.status === 401) {
      const re_token = getCookie("re_token");
      const refreshResult: QueryReturnValue<any, FetchBaseQueryError, FetchBaseQueryMeta> = await refleshToken(
        {
          url: "/auth/access",
          method: "POST",
          headers: {
            Authorization: `bearer ${re_token}`,
            "Content-Type": "application/json",
            Accept: "*/*, text/plain",
          },
        },
        api,
        extraOptions,
      );
      if (refreshResult.error?.status == 401) {
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage("");
        }
        logoutCookie();
        window.sessionStorage.clear();
        window.location.replace("/");
      } else {
        setCookie("ac_token", refreshResult.data.data["accessToken"]);
      }
      if (refreshResult.data) {
        result = await baseQuery(args, api, extraOptions);
      }
    } else {
      console.log(result);
    }
  } else {
    // console.log("세션 만료");
  }
  return result;
};

// 재요청
// const staggeredBaseQuery = retry(fetchBaseQuery({ baseUrl: serverIp + "/" }), {
//   maxRetries: 2,
// });

// const sample = fetchBaseQuery({
//   baseUrl: serverIp + "/",
//   prepareHeaders: (headers, { getState }) => {
//     const token = getCookie("ac_token");
//     const userInfo: any = jwtDecode(token);
//     const afterTime = userInfo.exp * 1000;
//     const currentTime = new Date().getTime();
//     const resultTime = afterTime - currentTime;
//     if (resultTime < 0) {
//       // const response = TokenRefresh();
//       // headers.set("Authorization", "bearer " + response);
//     }
//     return headers;
//   },
// });

// const baseFormat = fetchBaseQuery({ baseUrl: serverIp + "/" });
